module.exports = __webpack_public_path__ + "static/media/thumbnail-freechoicegroup.40d701c6.jpg";